import React from 'react'
import { SignUpEnterVerificationCodeForm } from '@/features/auth'
import { BaseView } from '@/components/base'
import { SignUpEnterVerificationCodeHeader } from '@/features'

export const SignUpEnterVerificationCodeScreen: React.FC = () => {
  return (
    <BaseView flex={1} gap={36} px={12}>
      <SignUpEnterVerificationCodeHeader />
      <SignUpEnterVerificationCodeForm />
    </BaseView>
  )
}
